import React, { useEffect, useRef, useState } from "react";

const AutoSizeTextCanvas = ({ text, textColor, bgColor }) => {

  const canvasRef = useRef(null);
  const fontFamily = "Inter";
  const fontSize = 14;
  const lineHeight = 1.8; // line spacing multiplier
  const padding = 5; // space around text
  const maxWidth = 600; // optional text wrap limit

  useEffect(() => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    if (!text || text.trim() === "") {
  canvas.width = 250;   // small width (does NOT collapse)
  canvas.height = 20;   // fixed reliable height
  ctx.clearRect(0, 0, canvas.width, canvas.height);
  return;
}


    ctx.font = `${fontSize}px ${fontFamily}`;
    ctx.textBaseline = "top";

    // Split text into lines (manual wrapping)
    const paragraphs = text?.split("\n");
    const wrappedLines = [];
    paragraphs?.forEach((p) => {
      const words = p?.split(" ");
      let line = "";
      words.forEach((word) => {
        const testLine = line ? line + " " + word : word;
        const { width } = ctx?.measureText(testLine);
        if (width > maxWidth && line) {
          wrappedLines?.push(line);
          line = word;
        } else {
          line = testLine;
        }
      });
      wrappedLines?.push(line);
    });

    const lineHeightPx = fontSize * lineHeight;
    const textWidth = Math.min(
      maxWidth,
      Math.max(...wrappedLines?.map((l) => ctx.measureText(l).width))
    );
    const textHeight = wrappedLines?.length * lineHeightPx;

    // Set canvas size based on text
    canvas.width = textWidth * 1.5;
    canvas.height = textHeight - 4;

    // Redraw after resizing (canvas reset clears content)
    ctx.font = `${fontSize}px ${fontFamily}`;
    ctx.textBaseline = "top";
    ctx.fillStyle = bgColor || "#fff";
    ctx.fillRect(0, 0, canvas?.width, canvas?.height);
    ctx.fillStyle = textColor || "#222";

    wrappedLines.forEach((line, i) => {
      ctx.fillText(line, padding, padding + i * lineHeightPx);
    });
  }, [text]);

  return (
      <canvas
        ref={canvasRef}
        style={{
          display: "inline-flex",
          maxWidth: "100%",
        }}
      />
  );
};
export default AutoSizeTextCanvas;